const bus = (() => {
  const subs = new Map();

  function subscribe(eventName, cb) {
    if (!subs.has(eventName)) subs.set(eventName, new Set());
    subs.get(eventName).add(cb);
    return () => subs.get(eventName).delete(cb);
  }

  function publish(eventName, data) {
    const set = subs.get(eventName);
    if (!set || set.size === 0) return;
    const handlers = Array.from(set);
    handlers.forEach((handler) => handler(data));
  }

  return { subscribe, publish };
})();

class YGImageLoader extends HTMLElement {
  getYGImageLoader () { // TODO: 命名优化
    if (!window.monvaneYGImageObserver) {
      window.monvaneYGImageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            const nextSrc = img.getAttribute('data-src');

            if (!nextSrc) {
              observer.unobserve(img);
              return;
            }

            img.src = nextSrc;
            img.removeAttribute('data-src');
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: "50px", // 预加载距离视口 50px 的图片
      });
    }
    return window.monvaneYGImageObserver;
  }
}

class YGVideoLoader extends HTMLElement {
  getYGVideoLoader () {
    if (!window.monvaneYGVideoObserver) {
      window.monvaneYGVideoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            const template = video.querySelector('template');
            if (template && video.dataset.ygVideoHydrated !== 'true') {
              video.dataset.ygVideoHydrated = 'true';
              video.appendChild(template.content.cloneNode(true));
            }
            
            observer.unobserve(video);
          }
        });
      }, {
        rootMargin: "400px",
      });
    }
    return window.monvaneYGVideoObserver;
  }
}
class YGUtils extends HTMLElement {
  get #getCurrentSlidesPerView() {
    if (!this['breakpoints']) return 1;

    const screenWidth = window.innerWidth;

    // 将breakpoints按数值从小到大排序
    const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

    let current = sortedKeys[0]; // 默认取最小的

    // 遍历找到小于等于当前屏幕宽度的最大key
    for (let i = 0; i < sortedKeys.length; i++) {
      if (screenWidth >= sortedKeys[i]) {
        current = sortedKeys[i];
      } else {
        break;
      }
    }
  
    return this['breakpoints'][current].slidesPerView;
  }

  #getAllAttributes(dom) {
    let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar', 'centered-slides'];
    let jsonAttrs = ['breakpoints']
    for (const attr of dom.attributes) {
      if (attr.name.startsWith('data-')) {
        const cleanName = attr.name.slice(5); // 去除 'data-' 前缀
        
        let value = attr.value;
        if (booleanAttrs.includes(cleanName)) {
          value = value === 'true';
        } else if (jsonAttrs.includes(cleanName)) {
          value = this.#parseSwiperBreakpoints(value);
        }

        this[cleanName] = value;
      }
    }
  }

  #parseSwiperBreakpoints(str) {
    const result = {};
    const pairs = str.split(',');

    for (const pair of pairs) {
      const [breakpoint, values] = pair.split(':');
      if (!breakpoint || !values) continue;
  
      const [slides, space] = values.split('-').map(Number);
  
      result[breakpoint.trim()] = {
        slidesPerView: slides,
        spaceBetween: space
      };
    }

    return result;
  }

  initSwiper(dom) {
    this.#getAllAttributes(dom || this);
    const swiper = new Swiper(dom || this, {
      // 这里放置 swiper 的配置
      effect: this['effect'],
      loop: this['loop'],
      centeredSlides: this['centered-slides'],
      autoplay: this['autoplay']?{
        delay: this['autoplay'],
        stopOnLastSlide: false,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      }:false,
      pagination: this['pagination']?{
        el: '.swiper-pagination',
        clickable: true,
      }:false,
      navigation: this['navigation']?{
        nextEl: this['navigation-class']? `.${this['navigation-class']}-next`:'.swiper-button-next',
        prevEl: this['navigation-class']? `.${this['navigation-class']}-prev`:'.swiper-button-prev',
      }:false,
      scrollbar: this['scrollbar']?{
        el: ".swiper-scrollbar",
        hide: true,
      }:false,
      breakpoints: this['breakpoints']?this['breakpoints']:false,
      on: {
        init: e => {
          if (e.passedParams.loop) {
            let num = this.#getCurrentSlidesPerView;
            let sliderLength = e.slides.length;

            if (this['centered-slides']) {
              num += 4;
            }

            if(sliderLength <= num){
              for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                e.slides.forEach((slide) => {
                  const clonedElement = slide.cloneNode(true);
                  e.slidesEl.appendChild(clonedElement);
                })
              }

              setTimeout(() => {
                let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                $bullets.forEach((bullet, index) => {
                  if (index >= sliderLength) {
                    bullet.style.display = 'none';
                  }
                })
              }, 250)
            }
          }
        }
      }
    })

    return swiper;
  }
}
